/** @jsxImportSource @emotion/react */
import { Popover } from "antd";
import { StatusBadge } from "../../../components/StatusBadge";
import { colors } from "../../../components/colors";
import { css } from "@emotion/react";
import { RestaurantsPopoverContent } from "./RestaurantsPopoverContent";
import * as authSelectors from "../../auth/authSelectors";
import { StyledText } from "../../../assets/typography/typography";
import { useSelector } from "react-redux";
import { useGetSalesChannelsUsingMenu } from "../service/menus-api";
import { useState } from "react";
import { useHandleFetchError } from "../../../error-handler";

type Props = {
  id: string;
  restaurantCount: number;
};

const buttonWrapperStyle = css`
  border: none;
  background-color: ${colors.transparent};
  padding: 0px;
  cursor: pointer;
  height: 100%;
`;

export const PublishedRestaurantsPopover = ({ id, restaurantCount }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const {
    data: salesChannels,
    error: getSalesChannelsError,
  } = useGetSalesChannelsUsingMenu(organizationKeyName, id, open);

  useHandleFetchError(getSalesChannelsError);

  if (restaurantCount === 0) {
    return (
      <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
        -
      </StyledText>
    );
  }

  return (
    <Popover
      content={<RestaurantsPopoverContent salesChannels={salesChannels} />}
      placement="bottom"
      arrow={false}
      open={open}
      onOpenChange={handleOpenChange}
    >
      <button type="button" css={buttonWrapperStyle}>
        <StatusBadge statusColor={colors.successMedium}>
          {restaurantCount}{" "}
          {restaurantCount === 1 ? "sales channel" : "sales channels"}
        </StatusBadge>
      </button>
    </Popover>
  );
};
